module.exports = __webpack_public_path__ + "static/media/13.bd5e008e.jpeg";